import React from 'react';
import { Link } from 'react-router-dom';
import { Star, MapPin } from 'lucide-react';
import { Restaurant } from '../../lib/types';
import { Card } from '../ui/Card';
import { Badge } from '../ui/Badge';
interface RestaurantCardProps {
  restaurant: Restaurant;
  zoneName?: string;
  tags?: string[];
}
export function RestaurantCard({
  restaurant,
  zoneName,
  tags = []
}: RestaurantCardProps) {
  return <Link to={`/r/${restaurant.slug}`} className="block group" data-id="element-256">
      <Card interactive className="h-full flex flex-col" data-id="element-257">
        {/* Cover Image */}
        <div className="relative h-48 w-full bg-gray-200 overflow-hidden" data-id="element-258">
          {restaurant.cover_url ? <img src={restaurant.cover_url} alt={restaurant.name} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-259" /> : <div className="w-full h-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center" data-id="element-260">
              <span className="text-gray-400 font-medium" data-id="element-261">Sin imagen</span>
            </div>}

          {/* Overlays */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-262" />

          <div className="absolute top-3 right-3 flex flex-col gap-2 items-end" data-id="element-263">
            {restaurant.is_featured && <Badge variant="warning" className="bg-brand-amber text-white shadow-sm" data-id="element-264">
                Destacado
              </Badge>}
            {!restaurant.is_open && <Badge variant="danger" className="shadow-sm" data-id="element-265">
                Cerrado
              </Badge>}
          </div>

          {/* Logo */}
          <div className="absolute -bottom-6 left-4" data-id="element-266">
            <div className="w-16 h-16 rounded-xl bg-white p-1 shadow-md border border-gray-100" data-id="element-267">
              {restaurant.logo_url ? <img src={restaurant.logo_url} alt={`${restaurant.name} logo`} className="w-full h-full rounded-lg object-cover" data-id="element-268" /> : <div className="w-full h-full rounded-lg flex items-center justify-center text-white font-bold text-xl" style={{
              backgroundColor: restaurant.primary_color || '#111827'
            }} data-id="element-269">
                  {restaurant.name.charAt(0)}
                </div>}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-5 pt-8 flex-1 flex flex-col" data-id="element-270">
          <div className="flex justify-between items-start mb-2" data-id="element-271">
            <h3 className="font-bold text-lg text-gray-900 line-clamp-1 group-hover:text-brand-amber transition-colors" data-id="element-272">
              {restaurant.name}
            </h3>
            <div className="flex items-center gap-1 bg-gray-50 px-2 py-1 rounded-md" data-id="element-273">
              <Star className="w-3.5 h-3.5 fill-brand-amber text-brand-amber" data-id="element-274" />
              <span className="text-xs font-semibold text-gray-700" data-id="element-275">4.8</span>
            </div>
          </div>

          <p className="text-sm text-gray-500 line-clamp-2 mb-4 flex-1" data-id="element-276">
            {restaurant.description_short || 'Deliciosa comida preparada con amor.'}
          </p>

          <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100" data-id="element-277">
            <div className="flex items-center text-xs text-gray-500 font-medium" data-id="element-278">
              <MapPin className="w-3.5 h-3.5 mr-1" data-id="element-279" />
              {zoneName || restaurant.address_text || 'Los Santos'}
            </div>

            <span className="text-xs font-semibold text-brand-amber group-hover:underline" data-id="element-280">
              {restaurant.is_open ? 'Ordenar aquí →' : 'Ver restaurante →'}
            </span>
          </div>
        </div>
      </Card>
    </Link>;
}